import React from 'react';

function Legend({ typesJournees }) {
    const types = typesJournees || [
        { code: 'F', libelle: 'Formation', couleur: '#1e293b' },
        { code: 'E', libelle: 'Entreprise', couleur: '#94a3b8' },
        { code: 'S', libelle: 'Stage', couleur: '#7C3AED' }
    ];

    const items = [
        { color: '#fee2e2', label: 'Jours fériés' },
        ...types.map(t => ({ color: t.couleur, label: t.libelle + ' (' + t.code + ')' }))
    ];

    return (
        <div className="legend">
            <div className="legend-grid">
                {items.map((item, idx) => (
                    <div key={idx} className="legend-item">
                        <div className="legend-color" style={{ background: item.color }} />
                        <span>{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Legend;